import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutGrid, Monitor, Smartphone } from 'lucide-react';
import { DmpLogo } from '../brand/DmpLogo';
import { BdFlag } from '../brand/BdFlag';
const links = [{
  to: '/',
  label: 'উপস্থাপনা',
  icon: LayoutGrid,
  end: true
}, {
  to: '/mobile',
  label: 'ট্রাফিক পুলিশ মোবাইল অ্যাপ',
  icon: Smartphone,
  end: false
}, {
  to: '/admin',
  label: 'ওয়েব অ্যাডমিন পোর্টাল',
  icon: Monitor,
  end: false
}];
export function PrototypeTopBar() {
  return <div className="print-hide sticky top-0 z-40 border-b border-border bg-white" data-id="element-158" data-mp="3qptrp2p1dy24">
      <div className="flex h-12 items-center gap-3 px-4" data-id="element-159" data-mp="3lzn14xays3h8">
        <DmpLogo size={28} data-id="element-160" data-mp="3ly2676kqmiiu" />
        <p className="hidden text-sm font-semibold text-navy-900 md:block" data-id="element-161" data-mp="3lxaggcdtnf0h">ডিএমপি কিউআর ভিত্তিক সিএনজি ও চালক যাচাই ব্যবস্থা</p>
        <nav className="ml-auto flex items-center gap-1" aria-label="প্রোটোটাইপ নেভিগেশন" data-id="element-162" data-mp="ib1ufflvkfdv">
          {links.map(({
          to,
          label,
          icon: Icon,
          end
        }) => <NavLink key={to} to={to} end={end} className={({
          isActive
        }) => `flex items-center gap-1.5 rounded-md px-2.5 py-1.5 text-xs font-medium ${isActive ? 'bg-navy-800 text-white' : 'text-slate-600 hover:bg-slate-100'}`} data-id="element-163" data-mp="dhqmtc98nukw">
              <Icon className="h-3.5 w-3.5" data-id="element-164" data-mp="3bsvq3fq8hpp7" />
              <span className="hidden sm:inline" data-id="element-165" data-mp="3brkn3i4m4lz5">{label}</span>
            </NavLink>)}
        </nav>
        <span className="hidden items-center gap-1.5 rounded-full border border-amber-200 bg-amber-50 px-2.5 py-1 text-[11px] font-semibold text-amber-700 lg:flex" data-id="element-166" data-mp="2xs1fcqfprcnd">
          প্রোটোটাইপ • নমুনা তথ্য
        </span>
        <BdFlag width={22} data-id="element-167" data-mp="2our61amghxl3" />
      </div>
    </div>;
}